export const COLORS = {
    green: {
        40: '#5AFF9C',
        50: '#40fe11',
    },
    yellow: {
        30: '#bee414',
        70: '#e4e114',
    },
    orange: '#e49414',
    grey: {
        0: '#ffffff',
        5: '#fafbfb',
        7: '#dfe9ed',
        10: '#acc0ca',
        15: '#8B9AA1',
        20: '#829097',
        40: '#566E7A',
        70: '#2D2F30',
        100: '#000000',
    },
    red: {
        70: '#FF3E3E',
        80: '#E72F2F',
        90: '#e43314',
    },
};
